import { Chart, registerables } from "chart.js";
import { GlobalVariablesService } from "../../services/global-variables.service";

export class ChartJsAverageEnergyGraph {


    graph: Chart;

    constructor(private globalVars: GlobalVariablesService){}

    draw(data: any[]){

        let xValues = [];
        let yValues = [];

        for(let i in data){
            let dataPoint = data[i];
            let date = new Date(dataPoint.timestamp);
            xValues.push(`${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`);
            yValues.push(dataPoint.value/1000);
        }

        Chart.register(...registerables);

        this.graph = new Chart('averageEnergy', {
            type: 'bar',
            data: {
                labels: xValues,
                datasets: [{
                    label: 'Energy Usage',
                    data: yValues,
                    backgroundColor: '#0E8E75'
                },
                ]

            }
            ,
            options: {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: 'Energy Usage'
                    },
                    tooltip: {
                        callbacks: {
                            footer: (point) => {
                                let value = point[0].parsed.y;

                                let tarrif = this.globalVars.getTarrif();

                                let cost = value * tarrif;

                                return "Cost: £" + cost.toFixed(2);
                            },
                            label: (point) => {
                                let value = point.parsed.y;
                                return " Energy " + value + " Wh";
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        ticks: {
                            callback: (value, index, values) => {
                                return value + 'Wh';
                            }
                        }

                    }
                }

            }
        }
        );

    }

}